import { css, keyframes } from 'styled-components';

export const reveal = keyframes`
  from {
    opacity: var(--reveal-from, 0);
  }

  to {
    opacity: 1;
  }
`;

export const slideInXStart = keyframes`
  from {
    translate: var(--slide-in-x-start-offset, -1rem) 0;
    pointer-events: none;
  }

  99% {
    pointer-events: none;
  }

  to {
    translate: 0 0;
  }
`;

export const slideInXEnd = keyframes`
  from {
    translate: var(--slide-in-x-end-offset, 1rem) 0;
    pointer-events: none;
  }

  99% {
    pointer-events: none;
  }

  to {
    translate: 0 0;
  }
`;

export const slideInYStart = keyframes`
  from {
    translate: 0 var(--slide-in-y-start-offset, -1rem);
    pointer-events: none;
  }

  99% {
    pointer-events: none;
  }

  to {
    translate: 0 0;
  }
`;

export const slideInYEnd = keyframes`
  from {
    translate: 0 var(--slide-in-y-end-offset, 1rem);
    pointer-events: none;
  }

  99% {
    pointer-events: none;
  }

  to {
    translate: 0 0;
  }
`;

export const scaleIn = keyframes`
  from {
    scale: var(--scale-in-size, 0);
  }

  to {
    scale: 1;
  }
`;

export const scaleOut = keyframes`
  from {
    scale: 1;
  }

  to {
    scale: var(--scale-out-size, 0);
  }
`;

export const subProperties = css`
  ${({ theme }) => css`
    animation-duration: var(--animation-duration, ${theme.base.animation.speed});
    animation-delay: var(--animation-delay, 0);
    animation-fill-mode: var(--animation-fill-mode, none);
    animation-timing-function: var(
      --animation-timing-function,
      ${theme.base.animation.timing.ease}
    );
  `}
`;
